import React, { useState } from "react";
import s from "./MobileHeader.module.scss";
import {
  CaretDownOutlined,
  CarOutlined,
  CloseOutlined,
  DashboardOutlined,
  ExceptionOutlined,
  GlobalOutlined,
  HomeOutlined,
  LogoutOutlined,
  PlusCircleOutlined,
  ToolOutlined,
  TruckOutlined,
  UserOutlined,
} from "@ant-design/icons";
import Search from "antd/es/input/Search";
import useWindowDimensions from "../WindowDimensions/WindowDimensions";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllSpares,
  getCarsByCategory,
  logout,
  setLang,
} from "../../redux/carSlice";
import { Button, Drawer, Dropdown, Menu, Modal, Space } from "antd";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";

const MobileHeader = () => {
  const { width } = useWindowDimensions();
  const categories = useSelector((state) => state.cars.categories);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const email = useSelector((state) => state.cars.email);
  const user = useSelector((state) => state.cars.userDetails);
  const location = useLocation();

  console.log("location", location);

  const lang = useSelector((state) => state.cars.lang);
  const { t } = useTranslation();

  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
    // dispatch(getNews());
    // dispatch(getTenders());
    // dispatch(getBoardMembers());
    // dispatch(getCouncilMembers());
    // dispatch(getContacts());
    // dispatch(getConsultants());
    // dispatch(getApprisers());
    // dispatch(getReports());
    // dispatch(getInsuranceCompanies());
    // params.id && dispatch(getTenderDetails(Number(params.id)));
    // params.id && dispatch(getNewsDetails(Number(params.id)));
  };
  const options4 = (
    <Menu>
      <Menu.Item key='1'>
        <div
          onClick={() => {
            dispatch(setLang("ru"));
            changeLang("ru");
          }}
        >
          RU
        </div>
      </Menu.Item>
      <Menu.Item key='2'>
        <div
          onClick={() => {
            dispatch(setLang("cn"));
            changeLang("cn");
          }}
        >
          CN
        </div>
      </Menu.Item>
    </Menu>
  );

  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const selectIcon = (category) => {
    if (category === "Легковые") {
      return <CarOutlined className={s.icon} />;
    }
    if (category === "Коммерческие") {
      return <TruckOutlined className={s.icon} />;
    }
    if (category === "Мото") {
      return <DashboardOutlined className={s.icon} />;
    }
    if (category === "Запчасти") {
      return <ToolOutlined className={s.icon} />;
    }
    if (category === "Спецтехника") {
      return <TruckOutlined className={s.icon} />;
    }
  };

  const categoryChangeHandler = async (id) => {
    if (id === 5) {
      dispatch(getAllSpares());
      navigate(`/category/${id}`);
    } else {
      dispatch(getCarsByCategory(id));
    }
    navigate(`/category/${id}`);
  };

  return (
    <div className={s.mobile_header}>
      <div className={s.top_header}>
        <div className={s.header_menu} onClick={() => showDrawer()}>
          <div className={s.menu_item}></div>
          <div className={s.menu_item}></div>
        </div>
        <div className={s.header_search}>
          <Link to='/' className={s.header_logo}>
            <CarOutlined />
            &nbsp; CNCars
          </Link>
          <div>
            {width > 450 ? (
              <Search
                placeholder='input search text'
                className={s.search_input}
              />
            ) : null}
          </div>
        </div>
        {/* <div className={s.header_btn}>
          <button className={s.btn}>+ Добавить объявление</button>
        </div> */}
        <div className={s.lang}>
          <Dropdown overlay={options4}>
            <ol>
              <div>
                <GlobalOutlined />
                &nbsp;{lang === "cn" ? "CN" : "RU"}{" "}
                <CaretDownOutlined style={{ fontSize: "12px" }} />
              </div>
            </ol>
          </Dropdown>
        </div>
      </div>
      {location.pathname === "/" ? (
        <div className={s.header_bottom}>
          {Array.isArray(categories) &&
            categories?.map((it) => (
              <div
                className={s.bottom_item}
                key={it.id}
                onClick={() => categoryChangeHandler(it.id)}
              >
                {selectIcon(it.name)}
                {it?.name}
              </div>
            ))}
        </div>
      ) : null}

      <Drawer
        placement='left'
        title={
          <Link to='/' className={s.header_logo}>
            <CarOutlined />
            &nbsp; CNCars
          </Link>
        }
        // onClose={onClose}
        open={open}
        closable={false}
        style={{ width: "90%" }}
        extra={
          <Space>
            <Button onClick={onClose} style={{ border: "none" }}>
              <CloseOutlined />
            </Button>
          </Space>
        }
      >
        <Link to='/myAccount' className={s.myAccount}>
          {user?.photo ? (
            <img src={user?.photo} className={s.photo} />
          ) : (
            <UserOutlined className={s.icon} />
          )}
          &nbsp;
          {user?.first_name || user?.last_name
            ? `${user?.first_name} ${user?.last_name} `
            : email}
        </Link>
        <div className={s.header_menu}>
          <Link to='/' className={s.menuItem}>
            <HomeOutlined className={s.icon} />
            Главная
          </Link>
          <Link to='/myAccount' className={s.menuItem}>
            <CarOutlined className={s.icon} />
            Мои машины
          </Link>
          <Link to='/mySpares' className={s.menuItem}>
            <ToolOutlined className={s.icon} />
            Мои запчасти
          </Link>
          <Link to='/addAnnoucement' className={s.menuItem}>
            <PlusCircleOutlined className={s.icon} /> Добавить объявление
          </Link>
          <Link to='/updateUser' className={s.menuItem}>
            <UserOutlined className={s.icon} /> Обновить профиль
          </Link>
          <div className={s.menuItem}>
            <LogoutOutlined className={s.icon} /> Выход
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default MobileHeader;
